import React from 'react';
import { DonutsRow } from './DonutsRow/DonutsRow';
import TableContainer from './StatsTable/TableContainer';
import { connect } from 'react-redux';
import * as basicAnalyticsActions from '../../actions/classroom/basicAnalyticsActions';
import * as drawerActions from '../../actions/drawerActions';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { CustomMonthPicker } from './CustomMonthPicker';
import { DRAWER_CONTENTS } from '../../const';
import Button from '@material-ui/core/Button';
import { I18n } from 'react-redux-i18n-lite';

export class ClassRoomBasicAnalytics extends React.Component {
  static propTypes = {
    analytics: PropTypes.array,
    sectionId: PropTypes.string,
    basicAnalyticsActions: PropTypes.any,
    drawerActions: PropTypes.any,
    date: PropTypes.object,
    selectedStudentIds: PropTypes.array
  };

  componentDidMount() {
    let { sectionId, date, basicAnalyticsActions, selectedStudentIds } = this.props;
    const studentIds = selectedStudentIds && selectedStudentIds.length > 0 ? selectedStudentIds : null;
    basicAnalyticsActions.manageBasicAnalyticsDate(sectionId, date, studentIds);
  }

  componentDidUpdate() {
    let { sectionId, date, analytics, basicAnalyticsActions, selectedStudentIds } = this.props;
    if (_.isEmpty(analytics)) {
      const studentIds = selectedStudentIds && selectedStudentIds.length > 0 ? selectedStudentIds : null;
      basicAnalyticsActions.manageBasicAnalyticsDate(sectionId, date, studentIds);
    }
  }

  componentWillUnmount() {
    let { basicAnalyticsActions } = this.props;
    basicAnalyticsActions.setBasicAnalyticsData();
  }

  handleOpenStudentFilter = () => {
    const { drawerActions } = this.props;
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.SELECT_STUDENTS_FOR_ANALYTICS);
  };

  handleDateChange = (sectionId, newDate) => {
    const { basicAnalyticsActions, selectedStudentIds } = this.props;
    const studentIds = selectedStudentIds && selectedStudentIds.length > 0 ? selectedStudentIds : null;
    basicAnalyticsActions.manageBasicAnalyticsDate(sectionId, newDate, studentIds);
  };

  render() {
    let { analytics, sectionId, date, selectedStudentIds } = this.props;
    const hasFilter = selectedStudentIds && selectedStudentIds.length > 0;
    const filterButtonText = hasFilter
      ? `${I18n.t('analytics.filterStudents.button')} (${selectedStudentIds.length})`
      : I18n.t('analytics.filterStudents.button');

    return (
      <div style={{ height: '100%', overflowY: 'auto' }}>
        <div className="basic-analytics-container">
          <div className="basic-analytics-toolbar">
            <CustomMonthPicker
              date={date}
              handleDate={this.handleDateChange}
              sectionId={sectionId}
            />
            <Button
              variant="outlined"
              color={hasFilter ? 'secondary' : 'primary'}
              onClick={this.handleOpenStudentFilter}
              size="small"
            >
              {filterButtonText}
            </Button>
          </div>
          <DonutsRow chartsData={analytics} />
          <TableContainer tableData={analytics} />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassRoomBasicAnalytics);

function mapStateToProps(state) {
  return {
    analytics: state.basicAnalytics.basicAnalyticsData,
    colors: state.theme.colors,
    sectionId: state.classrooms.selectedClassroom.classroom.sectionId,
    date: state.basicAnalytics.basicAnalyticsDate,
    selectedStudentIds: state.basicAnalytics.selectedStudentIds
  };
}

function mapDispatchToProps(dispatch) {
  return {
    basicAnalyticsActions: bindActionCreators(basicAnalyticsActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch)
  };
}
